import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';
import qs from "qs";

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getRetur(params) {
	return clientSupplier.get("api-supplier/por/data", {
		params: params,
	});
}

function getOptionStatusRetur() {
	return clientSupplier.get("api-supplier/options/retur-status");
}

function exportRetur(params) {
	return clientSupplier.get("api-supplier/por/export", {
		params: params,
	});
}

function detailRetur(params) {
	return clientSupplier.get("api-supplier/por/detail", {
		params: {
			por_code : params
		},
	});
}

function approveRetur (params) {
	return clientSupplier.post("api-supplier/por/approve", qs.stringify({
		por_id : params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function rejectRetur (params) {
	return clientSupplier.post("api-supplier/por/reject", qs.stringify({
		por_id : params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getRetur,
	getOptionStatusRetur,
	exportRetur,
	detailRetur,
	approveRetur,
	rejectRetur,
};